import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import { ReduxState } from 'types';
import { orgIsSuspended } from 'utils/models/Organization';

// Superusers are not locked out of organizations on hold (see ProtectedRoute
// and api/user.py) so support can keep working in them; this keeps the
// status visible while they do.
const OnHoldAlert: FC = () => {
  const currentOrganization = useSelector(
    (state: ReduxState) => state.currentOrganization
  );

  if (
    !currentOrganization?.is_super_admin ||
    !orgIsSuspended(currentOrganization)
  ) {
    return null;
  }

  return (
    <Alert className="mb-0 rounded-0 text-center" color="danger">
      <FormattedMessage
        id="app.views.layout.on_hold_alert.text"
        defaultMessage="<strong>{organization}</strong> is on hold. Its members are locked out, but superusers can still access it."
        description="Banner shown to superusers while they are in an organization that has been put on hold"
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
          organization: currentOrganization.name,
        }}
      />
    </Alert>
  );
};

export default OnHoldAlert;
